export class Estados {
    nombre: string;
    id: number;

    constructor (nombre: string, id: number){
        this.nombre=nombre;
        this.id=id;
    }
}